import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const baseStyles = {
    a: {
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.body,
        color: (theme: CarrotTheme) => theme.colors.text,
        alignItems: 'center',
        lineHeight: (theme: CarrotTheme) => theme.lineHeights.body,
        textDecoration: 'none',
        cursor: 'pointer',
        fontFamily: (theme: CarrotTheme) => theme.fonts.body,
        opacity: '1',
        ':hover, :focus': {
            opacity: '0.5',
            transition: 'opacity 0.15s ease-in',
        },
        borderBottom: (theme: CarrotTheme) => `1px solid ${theme.colors.carrotOrange35}`,
    },
};

const a: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
};
export default a;
